const initialState = {
    loading:false,
    info: {},
}

export default initialState